/* eslint-disable */

export interface Suspension {
  customer_id?: string;
  suspension_category?: SuspensionCategory;
}

/** Customer's current suspension state. */
export enum SuspensionState {
  NONE = "NONE",
  SUSPENDED = "SUSPENDED",
  VERIFIED = "VERIFIED",
}

/** The mechanism that created a customer's suspension. */
export enum SuspensionReason {
  AUTOMATIC_RISK = "AUTOMATIC_RISK",
  AUTOMATIC_COMPLIANCE = "AUTOMATIC_COMPLIANCE",
  MANUAL_RISK = "MANUAL_RISK",
  MANUAL_COMPLIANCE = "MANUAL_COMPLIANCE",
  BULK_RISK = "BULK_RISK",
}

/** Reason why a customer's suspension is resolved. */
export enum SuspensionResolvedReason {
  MANUAL = "MANUAL",
  AUTOMATIC = "AUTOMATIC",
  UPDATE = "UPDATE",
  PRE_SUSPENSION_EVALUATION = "PRE_SUSPENSION_EVALUATION",
}

/** Purpose of the suspension. */
export enum SuspensionCategory {
  ENHANCED_VERIFICATION = "ENHANCED_VERIFICATION",
  ACCOUNT_TAKEOVER = "ACCOUNT_TAKEOVER",
}

/** The source that caused a customer's suspension (i.e. "what we think they did wrong") */
export enum SuspensionSource {
  CHARGEBACK_LIMIT_VIOLATION = "CHARGEBACK_LIMIT_VIOLATION",
}

export interface SuspensionDecision {
  suspend_sender?: boolean;
  suspend_recipient?: boolean;
}
